/*
 * Knopjes om te kiezen hoeveel producten er naast elkaar staan (1, 2, 3 of 4).
 * De oude website had die in de balk bij het sorteren.
 *
 * Het thema zet het aantal kolommen met klassen zoals grid--4-col-desktop.
 * Die klasse wordt hier verwisseld. De keuze wordt niet onthouden: de pagina
 * opent altijd op de weergave die in de sectie staat ingesteld.
 */
(function () {
  var MOGELIJK = ['1', '2', '3', '4', '5'];
  // Keuze binnen deze pagina vasthouden: na filteren bouwt het thema het raster
  // opnieuw op en zou de keuze anders terugspringen. Bij een nieuwe pagina begint
  // het weer op de instelling van de sectie.
  var gekozen = null;

  function raster() {
    var el = document.getElementById('product-grid');
    // Op een categoriepagina heeft de lijst zelf dit id. Op de zoekresultatenpagina
    // heeft het omhullende blok het id en zit de lijst erin.
    if (el && el.classList.contains('product-grid')) return el;
    return document.querySelector('#product-grid .product-grid') || el;
  }

  function zetKolommen(aantal) {
    var grid = raster();
    if (!grid || MOGELIJK.indexOf(String(aantal)) === -1) return;

    MOGELIJK.forEach(function (n) {
      grid.classList.remove('grid--' + n + '-col-desktop');
    });
    grid.classList.add('grid--' + aantal + '-col-desktop');
    gekozen = String(aantal);

    document.querySelectorAll('[data-km-columns]').forEach(function (knop) {
      var actief = knop.dataset.kmColumns === String(aantal);
      knop.classList.toggle('km-grid-switcher__button--active', actief);
      knop.setAttribute('aria-pressed', actief ? 'true' : 'false');
    });
  }

  function huidigAantal() {
    var grid = raster();
    if (!grid) return null;

    var gevonden = null;
    MOGELIJK.forEach(function (n) {
      if (grid.classList.contains('grid--' + n + '-col-desktop')) gevonden = n;
    });
    return gevonden;
  }

  function start() {
    if (!raster()) return;
    // Altijd beginnen met de weergave die in de sectie is ingesteld (vier naast
    // elkaar). Bewust niet onthouden: dan opent de pagina elke keer hetzelfde.
    zetKolommen(gekozen || huidigAantal() || '4');
  }

  document.addEventListener('click', function (event) {
    var knop = event.target.closest('[data-km-columns]');
    if (!knop) return;
    event.preventDefault();
    zetKolommen(knop.dataset.kmColumns);
  });

  // Na het filteren vervangt het thema het raster; dan opnieuw toepassen.
  var doel = document.getElementById('ProductGridContainer');
  if (doel && window.MutationObserver) {
    new MutationObserver(function () {
      start();
    }).observe(doel, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
